package ru.dinarastepina.fabvocab.contracts

import kotlinx.serialization.Serializable

@Serializable
data class LookupWordRequest(
    val word: String,
)

@Serializable
data class SaveWordRequest(
    val word: WordEntryDto,
)

@Serializable
data class RecordExerciseResultRequest(
    val wordId: String,
    val exerciseType: String,
    val wasCorrect: Boolean,
)
